let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eJ7it")).then(() => parcelRequire('ax5Nk'));